import axios from "axios";
import { logout } from "../lib/auth";

import { CONST } from "../config/const";

//  顧客情報編集用 - エントリーフォーム選択肢一覧取得
export async function getOptionSelects(id: number) {
  try {
    const path = "optionSelects";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return [];
    }
    const optionSelects = response.data.fetch_data as {
      option_select: string;
    }[];
    return optionSelects;
  } catch (error) {
    return [];
    // logout();
  }
}

//  顧客情報編集用 - トスアップフォーム選択肢一覧取得
export async function getOptionSelectsTossUp(id: number) {
  try {
    const path = "optionSelectsTossUp";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return [];
    }
    const optionSelectsTossUp = response.data.fetch_data as {
      option_select: string;
    }[];
    return optionSelectsTossUp;
  } catch (error) {
    return [];
    // logout();
  }
}

//  顧客情報編集用 - 外部ETフォーム選択肢一覧取得
export async function getOptionSelectsOutside(id: number) {
  try {
    const path = "optionSelectsOutside";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return [];
    }
    const optionSelectsOutside = response.data.fetch_data as {
      option_select: string;
    }[];
    return optionSelectsOutside;
  } catch (error) {
    return [];
    // logout();
  }
}
